jQuery(function ($) {
  smooth_scroll_li();
  tm_slider();
  trusted_slider();
  testimonials_owl_slider();
  testimonial_readmore();
  testimonial__video();
  onscroll_show_icon_testimonial();

  jQuery(".contact-form-popup").fancybox({
    openEffect: "none",
    closeEffect: "none",
  });

  jQuery("#contact_form_pop p:has(> input.submit-contact-form)").addClass(
    "submit-cta"
  );
});

function smooth_scroll_li() {
  jQuery('.biz-top-space-bullets li a[href*="#"]').on("click", function (e) {
    e.preventDefault();

    var header_h = jQuery(".biztech-header").outerHeight();
    if (jQuery("header").hasClass("header_show")) {
      jQuery("html, body").animate(
        {
          scrollTop: jQuery(jQuery(this).attr("href")).offset().top - header_h,
        },
        400
      );
    } else {
      jQuery("html, body").animate(
        {
          scrollTop:
            jQuery(jQuery(this).attr("href")).offset().top - header_h - 20,
        },
        400
      );
    }
  });
}

function testimonials_owl_slider() {
  jQuery(".testimonial_owl_slider").owlCarousel({
    loop: false,
    margin: 0,
    nav: true,
    dots: false,
    items: 1,
    animateOut: "fadeOut",
    touchDrag: false,
    mouseDrag: false,
  });
}

function testimonial_readmore() {
  var showChar = 200; // How many characters are shown by default

  var moretext = "Read more";
  var lesstext = "Read less";

  jQuery(".testimonial_section_readmore .more").each(function () {
    var content = jQuery(this).html().trim();

    if (content.length > showChar) {
      var c = content.substr(0, showChar);
      var h = content.substr(showChar, content.length - showChar);

      var html =
        c +
        '<span class="dots">...</span><span class="morecontent">' +
        h +
        "</span>";

      var linkhtml =
        '<div class="link-wrap"><a href="#" class="morelink link_arrow" title="' +
        moretext +
        '">' +
        moretext +
        "</a></div>";

      jQuery(this).html(html);

      jQuery(linkhtml).insertAfter(this);
    }
  });

  jQuery(".testimonial_section_readmore .morelink").click(function () {
    if (jQuery(this).hasClass("less")) {
      jQuery(this).removeClass("less");
      jQuery(this).html(moretext);
      jQuery(this).attr("title", moretext);
    } else {
      jQuery(this).addClass("less");
      jQuery(this).html(lesstext);
      jQuery(this).attr("title", lesstext);
    }

    jQuery(this).parent().parent().find("span").toggle();
    return false;
  });
}

// Match Your Ingenuity video popup js start here
function testimonial__video() {
  jQuery(".testimonial_section .testimonial_single").fancybox({
    afterShow: function () {
      // After the show-slide-animation has ended - play the video
      this.content.find("video").trigger("play");
      // Trigger fancybox.close() once the video has ended
      this.content.find("video").on("ended", function () {
        $.fancybox.close();
      });
    },
  });
}

// onscroll show icon in testimonial right side js
function onscroll_show_icon_testimonial() {
  jQuery(window).on("scroll", function () {
    jQuery(".scroll_class").each(function () {
      if (isScrolledIntoView(jQuery(this))) {
        jQuery(this).addClass("active");
      }
    });
  });

  function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return elemBottom <= docViewBottom && elemTop >= docViewTop;
  }
}

// trusted_slider js
function trusted_slider() {
  jQuery(".trusted_slider").owlCarousel({
    loop: true,
    autoplay: true,
    margin: 0,
    nav: false,
    autoplayTimeout: 3000,
    slideSpeed: 2000,
    dots: false,
    responsive: {
      0: {
        items: 2,
      },

      700: {
        items: 3,
      },

      1100: {
        items: 4,
      },

      1366: {
        items: 5,
      },
    },
  });
}

// tm-slider js start
function tm_slider() {
  jQuery(".tm-slider").owlCarousel({
    items: 1,
    loop: true,
    margin: 0,
    nav: true,
    dots: false,
    autoplay: false,
    smartSpeed: 2200,
    autoplayTimeout: 4500,
    autoplayHoverPause: true,
    paginationSpeed: 1500,
    animateOut: "fadeOut",
    responsive: {
      768: {
        autoplay: true,
      },
    },
  });
}



// WEBPACK FOOTER //
// ./scripts/solutions/script.js